module.exports = createNode =>
    createNode({
        component: 'Grid',
        props: {
            preset: 'Compact',
            style: {
                backgroundColor: {
                    key: 'primary'
                }
            }
        },
        children: [
            createNode({
                component: 'Row',
                props: {
                    preset: 'Compact'
                },
                children: [
                    createNode({
                        component: 'Column',
                        width: 16,
                        props: {
                            preset: 'Big'
                        },
                        children: [
                            createNode({
                                component: 'Text',
                                props: {
                                    text: {
                                        blocks: [
                                            {
                                                key: '32423',
                                                text: 'Bred infoboks',
                                                type: 'Heading 2',
                                                depth: 0,
                                                inlineStyleRanges: [],
                                                entityRanges: [],
                                                data: {}
                                            }
                                        ],
                                        entityMap: {}
                                    },
                                    style: {
                                        color: {
                                            key: 'tint'
                                        }
                                    }
                                }
                            }),
                            createNode({
                                component: 'Text',
                                props: {
                                    text: {
                                        blocks: [
                                            {
                                                key: '32423',
                                                text:
                                                    'Giv et sammenfattende overblik med en grafisk afgrænset tekst, som opsummerer noget indhold med de væsentligste fakta og pointer. ',
                                                type: 'Normal',
                                                depth: 0,
                                                inlineStyleRanges: [],
                                                entityRanges: [],
                                                data: {}
                                            }
                                        ],
                                        entityMap: {}
                                    },
                                    style: {
                                        color: {
                                            key: 'tint'
                                        }
                                    }
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    })
